module.exports = {
    title: {
        en: "Ossian Wind Farm",
        cy: "",
    },

    description: {
        en: "Ossian is a proposed floating offshore wind farm, located off the east coast of Scotland, capable of delivering up to 3.6 GW of renewable energy.",
        cy: ""
    },

    socialImage: "/assets/images/social.jpg",

    company: {
        address: "",
        phoneNumber: "0800 138 5407",
        number: "",
    },

    email: "info@ossiantransmission.com"
}